import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

import Button from "../../../../../../Components/Button"
import EmptyComponent from "../../../../../../Components/Empty"
import { RoutesPaths } from "../../../../../../constants/user-routes"

// Empty state: distinguish "filters/search returned nothing" (offer a reset)
// from "this account genuinely has no disputes yet". Mirrors how Alerts
// branches on the total count. statistics.all is the unfiltered total.
// Activated but no processor connected yet (and no disputes): point them to Configure
// Step 1 instead of the generic "no disputes" copy that assumes a connection.
const TableEmpty = ({ filtersDirty, statistics, profileLoaded, noProcessor, onResetFilters }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return !filtersDirty && (statistics?.all ?? 0) === 0 && profileLoaded && noProcessor ? (
    <EmptyComponent type="connect_processor">
      <Button
        className="center"
        type="primary"
        onClick={() => navigate(RoutesPaths.recover.configure_section("integrations"))}
        text={t("Configure Recover")}
      />
    </EmptyComponent>
  ) : filtersDirty && (statistics?.all ?? 0) > 0 ? (
    <EmptyComponent type="search">
      <Button className="center" onClick={onResetFilters} text={t("Clear filters")} />
    </EmptyComponent>
  ) : (
    <EmptyComponent type="no_disputes" />
  )
}

export default TableEmpty
